// extracted by mini-css-extract-plugin
module.exports = {"space":"LayoutMobile_space__2yVFC","appbar":"LayoutMobile_appbar__39pHp","btn-color":"LayoutMobile_btn-color__3aQIy","nav-btm":"LayoutMobile_nav-btm__J_5Du"};